import { render, staticRenderFns } from "./TextBlob.vue?vue&type=template&id=0225805c&scoped=true&"
import script from "./TextBlob.vue?vue&type=script&lang=js&"
export * from "./TextBlob.vue?vue&type=script&lang=js&"
import style0 from "./TextBlob.vue?vue&type=style&index=0&id=0225805c&scoped=true&lang=css&"
import style1 from "./TextBlob.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225805c",
  null
  
)

export default component.exports